import { apiRequest } from "./api";
import { setCsrfToken } from "./csrf";
import type {
  CsrfResponseDto,
  AuthUserResponseDto,
  LoginRequestDto,
  ResendEmailVerificationRequestDto,
  RequestPasswordResetRequestDto,
  ResetPasswordRequestDto,
  SignupRequestDto,
  VerifyEmailRequestDto,
  VerifyEmailResponseDto,
} from "../types/types";

export const authApi = {
  async csrf(): Promise<CsrfResponseDto> {
    const response = await apiRequest<CsrfResponseDto>("/api/auth/csrf", { method: "GET" });
    setCsrfToken(response.token);
    return response;
  },

  me(): Promise<AuthUserResponseDto> {
    return apiRequest<AuthUserResponseDto>("/api/auth/me", { method: "GET" });
  },

  login(payload: LoginRequestDto): Promise<AuthUserResponseDto> {
    return apiRequest<AuthUserResponseDto>("/api/auth/login", {
      method: "POST",
      body: payload,
    });
  },

  signup(payload: SignupRequestDto): Promise<AuthUserResponseDto> {
    return apiRequest<AuthUserResponseDto>("/api/auth/signup", {
      method: "POST",
      body: payload,
    });
  },

  verifyEmail(payload: VerifyEmailRequestDto): Promise<VerifyEmailResponseDto> {
    return apiRequest<VerifyEmailResponseDto>("/api/auth/verify-email", {
      method: "POST",
      body: payload,
    });
  },

  resendEmailVerification(payload: ResendEmailVerificationRequestDto): Promise<void> {
    return apiRequest<void>("/api/auth/verify-email/resend", {
      method: "POST",
      body: payload,
    });
  },

  requestPasswordReset(payload: RequestPasswordResetRequestDto): Promise<void> {
    return apiRequest<void>("/api/auth/password-reset/request", {
      method: "POST",
      body: payload,
    });
  },

  resetPassword(payload: ResetPasswordRequestDto): Promise<void> {
    return apiRequest<void>("/api/auth/password-reset/confirm", {
      method: "POST",
      body: payload,
    });
  },

  logout(): Promise<void> {
    return apiRequest<void>("/api/auth/logout", {
      method: "POST",
    });
  },
};
